import { TSlugName } from 'shared/typings';

export const getOptionsFromSlug = (data: TSlugName[], map: Record<string, { name: string } | string>) => {
	return data
		.map(({ slug, name }) => ({
			value: slug,
			label: (typeof map?.[slug] === 'object' ? map?.[slug]?.name || name : map?.[slug] || name) as string,
		}))
		.sort((a, b) => (a.label as string)?.localeCompare(b.label as string));
};
